import React, { useMemo } from 'react';
import _ from 'lodash';
import {Box, Skeleton, Stack, Typography, useMediaQuery, useTheme} from '@mui/material';
import {useUser} from '../util/user.js';
import withMainContainer from '../components/WithMainContainer.js';
import CardContainer from '../components/CardContainer.js';
import {imagekitStaticURL} from '../util/util.js';
import WhatsAppButton from '../components/WhatsAppButton.js';
import SCButton from '../components/SCButton.js';
import { withLoginRequire } from '../components/Login.js';

const ProductThumbnail = props=>{
    let {image, title, href, permissions, purchaseCTA=null} = props;
    let [user, loading] = useUser();
    let hasPermission = useMemo(()=>{
        if (!permissions)
            return true;
        if (!user?.permissions?.length)
            return false;
        if (user.permissions.includes('admin'))
            return true;
        return user.permissions.some(up=>permissions.some(p=>p==up));
    }, [permissions, user]);
    return <CardContainer sx={{height: '100%', width: '300px'}}>
      <Box component="img" src={image}
        sx={{objectFit: 'cover', height: '150px', width: '100%'}}/>
      <Stack direction="column" gap={2} padding={2}>
        <Typography variant="h5">{title}</Typography>
        {(!user||loading) ? <Skeleton variant="rounded" width={200} height={30}/>
            : hasPermission&&href ? <SCButton text="כניסה" variant="outlined" href={href}/>
            : purchaseCTA}
      </Stack>
    </CardContainer>;
};

const SectionPanel = props=>{
    let {title, children} = props;
    let theme = useTheme();
    let sm = useMediaQuery(theme.breakpoints.down('sm'));
    return <Stack direction="column" gap={2}>
      <Typography variant="h3" textAlign={sm ? 'center' : 'right'}>{title}</Typography>
      <Stack direction={sm ? 'column' : 'row'} gap={2} alignItems={sm ? 'center' : null}>
        {children}
      </Stack>
    </Stack>
};

const StudentArea = ()=>{
    let apps = useMemo(()=>[{
        title: 'אפליקציית המסרים',
        image: imagekitStaticURL`tarot-banner.png`,
        href: '/tarotmail/student',
        permissions: ['tarotmail.student'],
        purchaseCTA: <WhatsAppButton text="לפרטים ורכישה"
          message="היי, אני מעוניינ.ת בפרטים לגבי אפליקציית המסרים"/>,
    }, {
        title: 'טרקו',
        image: imagekitStaticURL`banner-witchy.png`,
        permissions: ['tarako.host'],
        purchaseCTA: <Typography fontStyle="italic">בבנייה...</Typography>,
    }], []);
    return <Stack direction="column" gap={3} padding={3}>
      <SectionPanel title="האפליקציות שלי">
        {apps.map(app=><ProductThumbnail key={app.title} {...app}/>)}
      </SectionPanel>
    </Stack>;
};

export default withMainContainer(withLoginRequire(StudentArea), {footerMargin: 4});
